/**
 * StateMapperPreview  (DA-2184)
 *
 * The choiceless pickers author `stateMapper` directly, so they get no MapperPreview
 * panel — there are no clauses to serialize. This is the equivalent affordance: the exact
 * string that will be stored, echoed back under the cascade, so the admin can check the
 * grammar their picks resolved to rather than trusting the dropdowns blindly.
 */
import React from 'react'
import { Box, Typography } from '@mui/material'

export interface StateMapperPreviewProps {
  value?: string
}

export const StateMapperPreview: React.FC<StateMapperPreviewProps> = ({ value }) => (
  <Box sx={{ display: 'flex', gap: 1, alignItems: 'baseline', mt: 0.75 }}>
    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
      State mapper
    </Typography>
    <Typography
      variant="caption"
      sx={{ fontFamily: 'monospace', wordBreak: 'break-all', color: value ? 'text.primary' : 'text.disabled' }}
    >
      {value || '—'}
    </Typography>
  </Box>
)
